<route lang="yaml">
meta:
  public: true
</route>

<script setup lang="ts">
import LoadingPage from '@/components/loading/LoadingPage.vue'
import SAIFTYLanding from '@/components/landings/SAIFTYLanding.vue'
import MicrobrainsLanding from '@/components/landings/MicrobrainsLanding.vue'
import { useAuth } from '@/auth'
import { IS_BAYER, IS_MICROBRAINS, IS_INDUSTRIAL_IDENTITIES } from '@/config/customers'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

const auth = useAuth()
const router = useRouter()
const showLoadingWhileRedirecting = ref(false)
const SHOW_BLANK_PAGE_ON_HOME_REDIRECTION = window.ENV.SHOW_BLANK_PAGE_ON_HOME_REDIRECTION

onMounted(() => {
  if (!IS_BAYER && !IS_MICROBRAINS) {
    /*
    We redirect to dashboard page, if the user is authenticated he can see the home page, else he will be redirected
    automatically to the provider login page
    */
    showLoadingWhileRedirecting.value = true
    // NOTE: We want to remove the current index (landing) page, because it is unnecessary, so, we going to redirect the user to dashboard when the user set this URL path
    router.push({
      name: 'dashboard',
    })
  }
})

function callToAction() {
  auth.isAuthenticated ? router.push({ name: 'home' }) : auth.signup()
}

function login() {
  auth.loginWithRedirect()
}
</script>

<template>
  <template v-if="!showLoadingWhileRedirecting">
    <MicrobrainsLanding v-if="IS_MICROBRAINS" :call-to-action="callToAction" :login="login" />
    <SAIFTYLanding v-else :call-to-action="callToAction" :login="login" />
  </template>
  <div v-else-if="SHOW_BLANK_PAGE_ON_HOME_REDIRECTION"></div>
  <LoadingPage v-else />
</template>
